export const ROLES = {
  FRONT_END: 'Front-end',
  BACK_END: 'Back-end',
  FULL_STACK: 'Full-stack'
}



// WEBPACK FOOTER //
// ./src/config/developers/roles.js